import axios from "axios";
import { site_url } from "../config";
import { offlineDb } from "../db/offlineDb";

const getUuid = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `offline-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const saveOrderOffline = async (orderPayload) => {
  const offline_id = orderPayload.offline_id || getUuid();
  await offlineDb.orders.add({
    offline_id,
    order_data: {
      ...orderPayload,
      offline_id,
    },
    sync_status: "pending",
    created_at: new Date().toISOString(),
    last_error: null,
  });
  return offline_id;
};

export const getPendingOrderCount = async () => {
  return offlineDb.orders
    .where("sync_status")
    .anyOf(["pending", "failed"])
    .count();
};

export const getOfflineOrders = async () => {
  return offlineDb.orders.orderBy("created_at").reverse().toArray();
};

export const syncPendingOrders = async () => {
  const pendingOrders = await offlineDb.orders
    .where("sync_status")
    .anyOf(["pending", "failed"])
    .toArray();

  let synced = 0;
  let failed = 0;

  for (const row of pendingOrders) {
    try {
      await axios.post(`${site_url}/billorder`, row.order_data);
      await offlineDb.orders.update(row.id, {
        sync_status: "synced",
        last_error: null,
        synced_at: new Date().toISOString(),
      });
      synced += 1;
    } catch (error) {
      await offlineDb.orders.update(row.id, {
        sync_status: "failed",
        last_error:
          error?.response?.data?.message || error?.message || "Sync failed",
      });
      failed += 1;
    }
  }

  return {
    total: pendingOrders.length,
    synced,
    failed,
  };
};

